(function () {
    const SUBI_ROOT_SELECTOR = '.subify-root';
    const STICKY_SELECTOR = '.sticky-subscription';
    const ATC_COMPONENT_SELECTOR = 'add-to-cart-component';
    const PDP_FORM_SELECTOR = 'form[action="/cart/add"]';
    const PDP_ATC_SELECTOR = `${PDP_FORM_SELECTOR} button[type="submit"]`;
    const CHECK_INTERVAL = 300;
    const MAX_CHECKS = 10;

    const initializedWidgets = new WeakSet();
    const GLOBAL_SUBMIT_GUARD_KEY = '__stickySubmitGuardBound';

    function bindGlobalSubmitGuard() {
        if (document[GLOBAL_SUBMIT_GUARD_KEY]) return;

        document.addEventListener('submit', (event) => {
            const lockUntil = window.__stickySubmitLockUntil || 0;
            if (!lockUntil) return;
            if (Date.now() > lockUntil) {
                window.__stickySubmitLockUntil = 0;
                window.__stickySubmitHandled = false;
                return;
            }

            const form = event.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (form.getAttribute('action') !== '/cart/add') return;

            if (window.__stickySubmitHandled) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }

            window.__stickySubmitHandled = true;
        }, true);

        document[GLOBAL_SUBMIT_GUARD_KEY] = true;
    }

    function bindStickyVisibilityObserver(sticky) {
        if (!sticky || sticky.dataset.visibilityBound) return;
        const atcComponent = document.querySelector(ATC_COMPONENT_SELECTOR);
        if (!atcComponent) {
            sticky.classList.remove('is-hidden');
            sticky.dataset.visibilityBound = 'true';
            return;
        }

        function checkInitialVisibility() {
            const rect = atcComponent.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const isVisible = rect.bottom > 0 && rect.top < viewportHeight;
            if (isVisible) {
                sticky.classList.add('is-hidden');
            } else {
                sticky.classList.remove('is-hidden');
            }
        }

        checkInitialVisibility();

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (!entry) return;
            sticky.classList.toggle('is-hidden', entry.isIntersecting);
        }, { threshold: 0.01 });

        observer.observe(atcComponent);
        sticky.dataset.visibilityBound = 'true';
    }

    function initStickyWithoutRoots(sticky) {
        if (!sticky || sticky.dataset.noRootsInitialized) return;
        
        const stickySelectedVariant = sticky.querySelector('[data-selected-variant]');
        const stickySelectedPlan = sticky.querySelector('[data-selected-plan]');
        const stickyDropdownButton = sticky.querySelector('[data-dropdown-button]');
        const stickyActionsWrapper = sticky.querySelector('.sticky-subscription__actions-wrapper');
        const stickyButtonsWrapper = sticky.querySelector('.sticky-subscription__buttons-wrapper');
        const stickyVariantItems = sticky.querySelectorAll('.sticky-subscription__variants-item');
        const stickyAtc = sticky.querySelector('.sticky-subscription__atc-button');

        if (stickySelectedPlan) {
            stickySelectedPlan.style.display = 'none';
        }

        if (stickyButtonsWrapper) {
            stickyButtonsWrapper.style.display = 'none';
        }
        if (stickyDropdownButton && stickyActionsWrapper && !stickyDropdownButton.dataset.dropdownBound) {
            if (!sticky.dataset.resizeBound) {
                window.addEventListener('resize', () => {
                    if (!window.matchMedia('(max-width: 990px)').matches) {
                        stickyActionsWrapper.style.maxHeight = '';
                        stickyActionsWrapper.dataset.isOpen = 'false';
                        stickyDropdownButton.classList.remove('is-open');
                        stickyActionsWrapper.style.display = "flex"
                    }
                });
                sticky.dataset.resizeBound = 'true';
            }

            stickyDropdownButton.addEventListener('click', () => {
                if (!window.matchMedia('(max-width: 990px)').matches) return;
                const isOpen = stickyActionsWrapper.dataset.isOpen === 'true';
                if (isOpen) {
                    stickyActionsWrapper.style.maxHeight = '0px';
                    stickyActionsWrapper.dataset.isOpen = 'false';
                    stickyDropdownButton.classList.remove('is-open');
                    setTimeout(()=>{
                        stickyActionsWrapper.style.display = "none"
                    }, 150)
                    return;
                }
                stickyActionsWrapper.style.display = "flex"
                setTimeout(()=>{
                    stickyActionsWrapper.style.maxHeight = `${stickyActionsWrapper.scrollHeight}px`;
                    stickyActionsWrapper.dataset.isOpen = 'true';
                    stickyDropdownButton.classList.add('is-open');
                }, 0)
            });
            stickyDropdownButton.dataset.dropdownBound = 'true';
        }

        function updateSelectedVariant() {
            if (!stickySelectedVariant) return;
            const checkedInput = document.querySelector(
                '.variant-option__button-label input[type="radio"][data-input-id^="1-"]:checked'
            );
            stickySelectedVariant.textContent = checkedInput?.value || '';
        }

        function syncActiveVariant() {
            if (!stickyVariantItems.length) return;

            const checkedInput = document.querySelector(
                '.variant-option__button-label input[type="radio"][data-input-id^="1-"]:checked'
            );
            const selectedValue = checkedInput?.value;

            stickyVariantItems.forEach(item => {
                const optionValue = item.dataset.optionValue || item.textContent?.trim();
                item.classList.toggle('is-active', !!selectedValue && optionValue === selectedValue);
            });
        }

        function bindVariantSync() {
            if (sticky.dataset.variantSyncBound) return;
            const scope = sticky.closest('.shopify-section') || document;
            const variantForm = scope.querySelector('.variant-picker__form');
            if (!variantForm) return;

            variantForm.addEventListener('change', () => {
                updateSelectedVariant();
                syncActiveVariant();
            });

            sticky.dataset.variantSyncBound = 'true';
        }

        function bindStickyVariantClicks() {
            if (!stickyVariantItems.length || sticky.dataset.variantClicksBound) return;

            function findVariantLabelByValue(optionValue) {
                const inputs = document.querySelectorAll('.variant-option__button-label input[type="radio"]');
                return Array.from(inputs)
                    .find(input => input.dataset.inputId?.startsWith('1-') && input.value === optionValue)
                    ?.closest('label.variant-option__button-label');
            }

            stickyVariantItems.forEach(item => {
                item.addEventListener('click', () => {
                    const optionValue = item.dataset.optionValue || item.textContent?.trim();
                    if (!optionValue) return;

                    const label = findVariantLabelByValue(optionValue);
                    const input = label?.querySelector('input[type="radio"]');

                    if (input) input.click();
                    else if (label) label.click();

                    stickyVariantItems.forEach(variantItem => {
                        variantItem.classList.toggle(
                            'is-active',
                            variantItem === item
                        );
                    });

                    updateSelectedVariant();
                });
            });

            sticky.dataset.variantClicksBound = 'true';
        }

        function bindStickyAtc() {
            if (!stickyAtc || stickyAtc.dataset.atcBound) return;

            stickyAtc.addEventListener('click', () => {
                if (stickyAtc.dataset.atcLocked === 'true') return;
                stickyAtc.dataset.atcLocked = 'true';
                setTimeout(() => {
                    delete stickyAtc.dataset.atcLocked;
                }, 800);

                bindGlobalSubmitGuard();
                window.__stickySubmitLockUntil = Date.now() + 800;
                window.__stickySubmitHandled = false;

                const scope = sticky.closest('.shopify-section') || document;
                const pdpForm = scope.querySelector('product-form-component form[data-type="add-to-cart-form"]')
                    || scope.querySelector(PDP_FORM_SELECTOR);

                if (pdpForm) {
                    pdpForm.querySelectorAll('input[name="selling_plan"]').forEach(input => input.remove());
                    
                    if (typeof pdpForm.requestSubmit === 'function') {
                        pdpForm.requestSubmit();
                    } else {
                        pdpForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                    return;
                }

                const pdpAtc = scope.querySelector(PDP_ATC_SELECTOR);
                if (pdpAtc) {
                    pdpAtc.click();
                }
            });

            stickyAtc.dataset.atcBound = 'true';
        }

        updateSelectedVariant();
        syncActiveVariant();
        bindVariantSync();
        bindStickyVariantClicks();
        bindStickyAtc();
        bindStickyVisibilityObserver(sticky);

        sticky.dataset.noRootsInitialized = 'true';
    }

    function initStickyForRoot(subiRoot) {
        if (!subiRoot || initializedWidgets.has(subiRoot)) return;

        const sticky = document.querySelector(STICKY_SELECTOR);
        if (!sticky) return;

        const stickyOneTime = sticky.querySelector('[data-type="onetime"]');
        const stickySubscribe = sticky.querySelector('[data-type="subscription"]');
        const stickyAtc = sticky.querySelector('.sticky-subscription__atc-button');
        const stickyPriceOneTime = sticky.querySelector('.sticky-price-onetime');
        const stickyPriceSubscription = sticky.querySelector('.sticky-price-subscription');
        const stickyPriceSubscriptionCompareTaPrice = sticky.querySelector('.sticky-price-subscription__compare_at_price');
        const stickyVariantItems = sticky.querySelectorAll('.sticky-subscription__variants-item');
        const stickyActionsWrapper = sticky.querySelector('.sticky-subscription__actions-wrapper');
        const stickyDropdownButton = sticky.querySelector('[data-dropdown-button]');
        const stickyButtonsWrapper = sticky.querySelector('.sticky-subscription__buttons-wrapper');
        const stickySelectedVariant = sticky.querySelector('[data-selected-variant]');
        const stickySelectedPlan = sticky.querySelector('[data-selected-plan]');
        const stickyDiscountContainer = sticky.querySelector('[data-discount-container]');
        const stickyDiscountValue = sticky.querySelector('[data-discount-value]');
        if (!stickyOneTime || !stickySubscribe || !stickyPriceOneTime || !stickyPriceSubscription) return;

        if (stickyDropdownButton) {
            stickyDropdownButton.style.display = '';
        }
        if (stickyButtonsWrapper) {
            stickyButtonsWrapper.style.display = '';
        }
        if (stickySelectedPlan) {
            stickySelectedPlan.style.display = '';
        }

        initializedWidgets.add(subiRoot);


        function updateSelectedVariant() {
            if (!stickySelectedVariant) return;
            const checkedInput = document.querySelector(
                '.variant-option__button-label input[type="radio"][data-input-id^="1-"]:checked'
            );
            stickySelectedVariant.textContent = checkedInput?.value || '';
        }

        function updateSelectedPlan() {
            if (!stickySelectedPlan) return;
            stickySelectedPlan.style.display = '';
            const activeBox = subiRoot.querySelector('.subify-choice-box-wrapper.active');
            if (activeBox?.querySelector('#subify-widget-subscription-text')) {
                const label = activeBox.querySelector('#subify-widget-subscription-text');
                stickySelectedPlan.textContent = label?.textContent?.trim() || '';
                return;
            }
            const oneTimeLabel = subiRoot.querySelector('#subify-widget-one-time-purchase-text');
            stickySelectedPlan.textContent = oneTimeLabel?.textContent?.trim() || '';
        }

        function updateDiscountValue() {
            if (!stickyDiscountValue) return;
            const activeBox = subiRoot.querySelector('.subify-choice-box-wrapper.active');
            const discountEl = activeBox?.querySelector('.subify-max-discount-badge-percentage');
            const value = discountEl?.textContent?.trim() || '';
            if (stickyDiscountContainer) {
                stickyDiscountContainer.style.display = '';
            }
            if (value) {
                stickyDiscountValue.textContent = value;
            }
        }

        function syncActiveVariant() {
            if (!stickyVariantItems.length) return;

            const checkedInput = document.querySelector(
                '.variant-option__button-label input[type="radio"][data-input-id^="1-"]:checked'
            );
            const selectedValue = checkedInput?.value;

            stickyVariantItems.forEach(item => {
                const optionValue = item.dataset.optionValue || item.textContent?.trim();
                item.classList.toggle('is-active', !!selectedValue && optionValue === selectedValue);
            });
        }

        function syncState() {
            const allChoiceBoxes = subiRoot.querySelectorAll('.subify-choice-box-wrapper');

            allChoiceBoxes.forEach(box => {
                const oneTimeLabel = box.querySelector('#subify-widget-one-time-purchase-text');
                const subscriptionLabel = box.querySelector('#subify-widget-subscription-text');
                const priceEl = box.querySelector('.subify-choice-price');

                if (oneTimeLabel && stickyPriceOneTime) stickyPriceOneTime.textContent = priceEl ? priceEl.textContent : '';
                if (subscriptionLabel && stickyPriceSubscription) stickyPriceSubscription.textContent = priceEl ? priceEl.textContent : '';
                if (subscriptionLabel && stickyPriceSubscriptionCompareTaPrice) stickyPriceSubscriptionCompareTaPrice.textContent = stickyPriceOneTime.textContent ? stickyPriceOneTime.textContent : '';
            });

            const activeBox = subiRoot.querySelector('.subify-choice-box-wrapper.active');
            const isSubscription = !!activeBox?.querySelector('#subify-widget-subscription-text');
            stickySubscribe.classList.toggle('is-active', isSubscription);
            stickyOneTime.classList.toggle('is-active', !isSubscription);
            sticky.dataset.isSubscription = isSubscription ? 'true' : 'false';

            syncActiveVariant();
            updateSelectedVariant();
            updateSelectedPlan();
            updateDiscountValue();
        }

        syncState();

        const observer = new MutationObserver(syncState);
        observer.observe(subiRoot, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style'],
            childList: true
        });

        function findVariantLabelByValue(optionValue) {
            const inputs = document.querySelectorAll('.variant-option__button-label input[type="radio"]');
            return Array.from(inputs)
                .find(input => input.dataset.inputId?.startsWith('1-') && input.value === optionValue)
                ?.closest('label.variant-option__button-label');
        }

        function bindStickySubmitGuard(form) {
            if (!form || form.dataset.stickySubmitGuardBound) return;

            form.addEventListener('submit', (event) => {
                const until = Number(form.dataset.stickySubmittingUntil || 0);
                if (!until) return;

                if (Date.now() > until) {
                    delete form.dataset.stickySubmittingUntil;
                    delete form.dataset.stickySubmitHandled;
                    return;
                }

                if (form.dataset.stickySubmitHandled === 'true') {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return;
                }

                form.dataset.stickySubmitHandled = 'true';
            }, true);

            form.dataset.stickySubmitGuardBound = 'true';
        }

        function bindStickyVariantClicks() {
            if (!stickyVariantItems.length || sticky.dataset.variantClicksBound) return;

            stickyVariantItems.forEach(item => {
                item.addEventListener('click', () => {
                    const optionValue = item.dataset.optionValue || item.textContent?.trim();
                    if (!optionValue) return;

                    const label = findVariantLabelByValue(optionValue);
                    const input = label?.querySelector('input[type="radio"]');

                    if (input) input.click();
                    else if (label) label.click();

                    stickyVariantItems.forEach(variantItem => {
                        variantItem.classList.toggle(
                            'is-active',
                            variantItem === item
                        );
                    });
                });
            });

            sticky.dataset.variantClicksBound = 'true';
        }
        function clickLabelBySelector(selectorId) {
            setTimeout(() => {
                const allChoiceBoxes = subiRoot.querySelectorAll('.subify-choice-box-wrapper');
                const label = Array.from(allChoiceBoxes)
                    .find(box => box.querySelector(selectorId))
                    ?.querySelector('label.checkbox-label');

                if (label && !label.classList.contains('active')) {
                    label.click();
                }
            }, 0);
        }

        stickyOneTime.addEventListener('click', () => clickLabelBySelector('#subify-widget-one-time-purchase-text'));
        stickySubscribe.addEventListener('click', () => clickLabelBySelector('#subify-widget-subscription-text'));
        bindStickyVariantClicks();
        updateSelectedVariant();
        updateSelectedPlan();
        updateDiscountValue();
        bindStickyVisibilityObserver(sticky);

        function bindVariantPlanSync() {
            if (sticky.dataset.variantPlanSyncBound) return;
            const scope = sticky.closest('.shopify-section') || document;
            const variantForm = scope.querySelector('.variant-picker__form');
            if (!variantForm) return;

            variantForm.addEventListener('change', () => {
                if (sticky.dataset.isSubscription !== 'false') return;
                setTimeout(() => {
                    clickLabelBySelector('#subify-widget-one-time-purchase-text');
                }, 0);
            });

            sticky.dataset.variantPlanSyncBound = 'true';
        }

        bindVariantPlanSync();

        if (stickyDropdownButton && stickyActionsWrapper && !stickyDropdownButton.dataset.dropdownBound) {
            if (!sticky.dataset.resizeBound) {
                window.addEventListener('resize', () => {
                    if (!window.matchMedia('(max-width: 990px)').matches) {
                        stickyActionsWrapper.style.maxHeight = '';
                        stickyActionsWrapper.dataset.isOpen = 'false';
                        stickyDropdownButton.classList.remove('is-open');
                        stickyActionsWrapper.style.display = "flex"
                    }
                });
                sticky.dataset.resizeBound = 'true';
            }

            stickyDropdownButton.addEventListener('click', () => {
                if (!window.matchMedia('(max-width: 990px)').matches) return;
                const isOpen = stickyActionsWrapper.dataset.isOpen === 'true';
                if (isOpen) {
                    stickyActionsWrapper.style.maxHeight = '0px';
                    stickyActionsWrapper.dataset.isOpen = 'false';
                    stickyDropdownButton.classList.remove('is-open');
                    setTimeout(()=>{
                        stickyActionsWrapper.style.display = "none"
                    }, 150)
                    return;
                }
                stickyActionsWrapper.style.display = "flex"
                setTimeout(()=>{
                    stickyActionsWrapper.style.maxHeight = `${stickyActionsWrapper.scrollHeight}px`;
                    stickyActionsWrapper.dataset.isOpen = 'true';
                    stickyDropdownButton.classList.add('is-open');
                }, 0)
            });
            stickyDropdownButton.dataset.dropdownBound = 'true';
        }

        if (stickyAtc && !stickyAtc.dataset.atcBound) {
            stickyAtc.addEventListener('click', () => {
                if (stickyAtc.dataset.atcLocked === 'true') return;
                stickyAtc.dataset.atcLocked = 'true';
                setTimeout(() => {
                    delete stickyAtc.dataset.atcLocked;
                }, 800);

                bindGlobalSubmitGuard();
                window.__stickySubmitLockUntil = Date.now() + 800;
                window.__stickySubmitHandled = false;

                const scope = sticky.closest('.shopify-section') || document;
                const pdpForm = scope.querySelector('product-form-component form[data-type="add-to-cart-form"]')
                    || scope.querySelector(PDP_FORM_SELECTOR);

                if (pdpForm) {
                    if (sticky.dataset.isSubscription === 'false') {
                        pdpForm.querySelectorAll('input[name="selling_plan"]').forEach(input => input.remove());
                    }
                    bindStickySubmitGuard(pdpForm);
                    pdpForm.dataset.stickySubmittingUntil = String(Date.now() + 800);
                    delete pdpForm.dataset.stickySubmitHandled;
                    if (typeof pdpForm.requestSubmit === 'function') {
                        pdpForm.requestSubmit();
                    } else {
                        pdpForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                    return;
                }

                const pdpAtc = scope.querySelector(PDP_ATC_SELECTOR);
                if (pdpAtc) {
                    pdpAtc.click();
                    return;
                }

                subiRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
            stickyAtc.dataset.atcBound = 'true';
        }

        console.log('[Subify Sticky] Initialized for root:', subiRoot);

        const removalObserver = new MutationObserver(() => {
            if (!document.body.contains(subiRoot)) {
                observer.disconnect();
                removalObserver.disconnect();
                console.log('[Subify Sticky] Observer disconnected for removed root:', subiRoot);
            }
        });

        removalObserver.observe(document.body, { childList: true, subtree: true });
    }

    let checks = 0;
    const intervalId = setInterval(() => {
        const sticky = document.querySelector(STICKY_SELECTOR);
        if (!sticky) return;
        
        const roots = document.querySelectorAll(SUBI_ROOT_SELECTOR);
        
        checks += 1;
        
        bindStickyVisibilityObserver(sticky);
        
        if (roots.length > 0) {
            roots.forEach(root => initStickyForRoot(root));
            clearInterval(intervalId);
            return;
        }
        
        if (checks >= MAX_CHECKS) {
            initStickyWithoutRoots(sticky);
            clearInterval(intervalId);
            return;
        }
    }, CHECK_INTERVAL);
})();